import * as dateAndTime from "date-and-time";
import SharedPreferences from "./SharedPreferences";
import { STORAGE_KEYS } from "../../data/constant/Constants";

export function formateDate(
  date: Date,
  formatText: string = "DD MMM YYYY hh:mm A",
) {
  return dateAndTime.format(new Date(date), formatText);
}

export function capitalizeFirstLetters(str: string) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}
export const formatEnumLabel = (value: string): string => {
  return (
    value
      // 1. Find a lowercase letter followed by an uppercase letter
      // 2. Insert a space between them
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      // 3. Optional: Ensure the first letter is capitalized
      .trim()
  );
};

export function titleCaseWord(word: string) {
  if (!word) return word;
  return word[0].toUpperCase() + word.substr(1).toLowerCase();
}

export function hasEnglishLetters(word: string): boolean {
  return /[a-zA-Z]/.test(word);
}

export function getDominantColorOfImage(
  src: string,
): Promise<Uint8ClampedArray> {
  return new Promise((resolve) => {
    let context = document.createElement("canvas").getContext("2d");
    context!.imageSmoothingEnabled = true;

    let img = new Image();
    img.src = src;
    img.crossOrigin = "";

    img.onload = () => {
      context!.drawImage(img, 0, 0, 1, 1);
      resolve(context!.getImageData(0, 0, 1, 1).data.slice(0, 3));
    };
  });
}

export function showGlobalLoadingView(show: boolean) {
  SharedPreferences.setBoolean(STORAGE_KEYS.SHOW_LOADING, show);
}

export function convertMillisecondsToSecondsString(ms: number): string {
  return (ms / 1000).toFixed(1);
}
